<template>
  <div class="page-content special-activity-details">
    <el-row class="search-title">
      <el-col :span="4" style="text-align: left;">
          <i class="el-icon-document" style="color: #4882ff;font-size: 18px;font-weight: bold;margin-left: 10px"></i>
          <span class="order-list-search-span" style="margin-left: 6px">记录详情</span>
      </el-col>
      <el-col :span="20" class="text-align-right">
      </el-col>
    </el-row>
    <el-row class="box-content">
      <el-col>
        <div class="box-content-div">
          <el-col class="con_title">
            <span class="order-list-search-span" style="margin-left: 6px">基本信息</span>
          </el-col>
          <el-form :inline="false" :model="formInline" class="box-content-form" label-width="100px">
            <el-form-item label="姓名:">
                <p class="con_p">{{formInline.saleman}}</p>
            </el-form-item>
            <el-form-item label="手机号:">
                <p class="con_p">{{formInline.mobile}}</p>
            </el-form-item>
            <el-form-item label="部门:">
                <p class="con_p">{{formInline.structure}}</p>
            </el-form-item>
          </el-form>
          <el-col class="con_title" v-if="field_arr.length>0">
            <span class="order-list-search-span" style="margin-left: 6px">其他字段</span>
          </el-col>
          <div class="drag-content" v-for="(i, item) in field_arr" :key="item.index">
            <div class="must-write" v-if="(item.isRequired === 1 && item.type === 'input') || (item.isRequired === 1 && item.type === 'cascader') || (item.isRequired === 1 & item.type === 'select') || (item.isRequired === 1 && item.type === 'dateTimePicker')">*</div>
            <label>{{item}}:</label>
            <span style="font-size: 14px">{{i}}</span>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { API_HOST } from '@/api/local'
import { getQrcodeDetails, getStructureList, getWeChatActivityDetails } from '@/api/customer.js'
import { regionData, CodeToText, TextToCode } from 'element-china-area-data'
export default {
  name: '',
  data () {
    return {
      formInline: {},
      structure: '',
      radio: '',
      checkout: '',
      items: '',
      value: '',
      isRequired: 0,
      textRadio: 1,
      textType: '',
      structureOptions: [],
      selectOptions: [],
      otherArray: [],
      addressOptions: regionData,
      other_field: [],
      field_arr: {}
    }
  },
  methods: {
    getData() {
      let id = this.$route.query.id
      getQrcodeDetails(id).then((res) => {
        this.formInline = res.data.data
        for (let item of res.data.data.data) {
          for (let i of this.other_field) {
            if (i == item.name) {
              this.field_arr[i] = item.value
            }
          }
        }
        console.log(this.field_arr, 'fff')
      })
    },
    getActivityData() {
      let id = this.$route.query.activity_id
      getWeChatActivityDetails(id).then(res => {
        for (let item of res.data.data.activity_data) {
          if (
            item.type == 'radio' ||
            item.type == 'checkBox' ||
            item.type == 'cascader'
          ) {
            // console.log(item.name, typeof item.value)
            item.value = item.value.join(',')
          }
          this.other_field.push(item.name)
        }
        this.otherArray = res.data.data.activity_data
        // console.log(this.otherArray)
        console.log(this.other_field)
      })
    }
  },
  created() {
    this.getActivityData()
    this.getData()
  },
  components: {
  }
}
</script>

<style scoped>
.con_p{
  margin: 0;
  text-align: left;
  padding-left: 10px;
}
.con_title{
  text-align: left;
  height: 50px;
  font-weight: 600;
  line-height: 50px;
  padding-left: 15px;
  font-size: 14px;
  margin-bottom: 10px;
}
.icon1,.icon2{
  width:220px;
  height:50px;
  line-height: 50px;
  background:#9EA7B4;
  text-align: center;
  position: absolute;
  box-sizing: border-box;
  font-size: 16px;
  color:#fff;
}
.icon1{
  top:80px;
  left:0;
}
.icon2{
  top:430px;
  left:0;
}
/*向右*/
.triangle_border_right{
  width:0;
  height:0;
  border-width:25px 0 25px 20px;
  border-style:solid;
  border-color:transparent transparent transparent #9ea7b4;
  position: absolute;
}
.up, .down{
  position: relative;
}
.up .triangle_border_right{
  top:80px;
  left:220px;
}
.down .triangle_border_right{
  top:430px;
  left:220px;
}
.box-content{
width: 100%;
background: #fff;
position: relative;
margin: 20px 0 0;
}
.drag-content label{
  min-width:100px;
  text-align: right;
  font-size: 14px;
  color: #606266;
  line-height: 40px;
  padding: 0 12px 0 0;
  box-sizing: border-box;
  margin:30px 7%;
}
.content-one span {
  display: inline-block;
  float: left;
  line-height: 20px;
  font-size: 16px;
  margin-top: 10px;
}
.content-one p {
  text-align: left;
}
.box-content-div {
 /* margin-left: 20%;
  padding:80px 0 20px 10%;*/
  /*background: #fff;*/
  min-height:700px;
  width: 100% !important;
}
.box-content{
  border: 1px solid #ebebeb;
}
.radio-cont{
  clear:both;
}
.box-content-form {
  /*margin-top: 10px;*/
  text-align: center;
  /*margin-bottom: 100px;*/
}
.box-content-form .el-form-item {
  width: 400px;
  margin-bottom: 0px;
  margin: 0 auto;
}
.acivity-input {
  width:300px;
  margin:30px auto;
}
</style>
